// ©2024 Austin App House. All rights reserved.
import React, { memo } from 'react';
import { MDBTooltip } from 'mdbreact';
import { localCurrencySettings } from '../../../../../../utils/constans';
import TooltipTitle from './TooltipTitle';

const AmountInfo = ({
  amountBase = 0,
  amountVariable = 0,
  basicWorkType,
  bidBasicType,
  variableWorkType,
  bidAmountBase = 0,
  bidAmountVariable = 0,
  current = false,
}) => {
  const isOriginalOffer =
    bidAmountBase === amountBase
    && (!bidAmountVariable || bidAmountVariable === amountVariable);

  const colorClass = current
    ? 'color-current'
    : isOriginalOffer
      ? 'color-default'
      : 'color-warning';

  const displayType = bidBasicType || basicWorkType;

  return (
    <div className="white-tooltip-title">
      <MDBTooltip domElement placement="top">
        <div className={`amount-value ${colorClass}`}>
          {`${bidAmountBase.toLocaleString(
            'en-US',
            localCurrencySettings,
          )} / ${displayType}`}
        </div>

        <div className="amount-tooltip-title tooltip-content">
          <TooltipTitle
            amountBase={amountBase}
            amountVariable={amountVariable}
            basicWorkType={basicWorkType}
            variableWorkType={variableWorkType}
            bidAmountBase={bidAmountBase}
            bidAmountVariable={bidAmountVariable}
          />
        </div>
      </MDBTooltip>
    </div>
  );
};


export default memo(AmountInfo);